import { lazy } from 'react';

const routes = [
  { path: '/', Element: lazy(() => import('./views/pages/Dashboard')) },
  { path: '/doctor/register', Element: lazy(() => import('./views/pages/DoctorRegister')) },
  { path: '/consult', Element: lazy(() => import('./views/pages/Consult')) },
  { path: '/consult/:refCode', Element: lazy(() => import('./views/pages/ConsultComplete')) },
  { path: '/setting', Element: lazy(() => import('./views/settings/Index')) },
  { path: '/setting/schedules', Element: lazy(() => import('./views/settings/ConsultSchedules')) },
  { path: '/chats', Element: lazy(() => import('./views/pages/ChatLists')) },
  { path: '/chats/:token', Element: lazy(() => import('./views/pages/Chats')) },
  { path: '/patients', Element: lazy(() => import('./views/pages/Patients')) },
  { path: '/wallet', Element: lazy(() => import('./views/pages/Wallet')) },
  { path: '/profile', Element: lazy(() => import('./views/auth/Profile')) },
  { path: '/closeAccount', Element: lazy(() => import('./views/auth/CloseAccount')) }
];

export default routes;
